import { useAppDispatch, useAppSelector } from "app/hooks"
import { useEffect } from "react"
import { useParams } from "react-router-dom"
import { MealType } from "model/food/types"
import {
  getFavoriteMealDetails,
  setFavoriteMealDetails,
} from "../favoriteMealsSlice"

export const useFavoriteMealDetails = () => {
  const { id } = useParams()
  const favoriteMealDetails = useAppSelector(
    (state) => state.favoriteMeals.favoriteMealDetails,
  )
  const getFavoriteMealDetailsLoading = useAppSelector(
    (state) => state.favoriteMeals.getFavoriteMealDetailsLoading,
  )
  const dispatch = useAppDispatch()

  useEffect(() => {
    if (id && id !== favoriteMealDetails?.id) {
      setFavoriteMealDetails(undefined)
      dispatch(getFavoriteMealDetails(id))
    }
  }, [id])

  return {
    getFavoriteMealDetailsLoading,
    favoriteMealDetails,
  }
}

export const useSetFavoriteMealDetails = () => {
  const dispatch = useAppDispatch()

  return (favoriteMealDetails: MealType) => {
    dispatch(setFavoriteMealDetails(favoriteMealDetails))
  }
}
